var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");

var PcbHole = function () {
    lib_core.AbstractInstance.call(this);

    this.onInit("onInit", this.initialize, 10);
};
lib_core.inherit(PcbHole, lib_core.AbstractInstance);

module.exports = PcbHole;

lib_core.JsonParser.registerClass(PcbHole, "PcbHole");

PcbHole.prototype.initialize = function () {
    var self = this;

    this.pos = this.shadow("pos",
        function(){
            var pos = self.description().getPos();
            if(!self.parent().onTopLayer()) {
                var flipLine = new lib_geometry.Line(new lib_geometry.Coord(0,1), new lib_geometry.Coord(0,0));
                pos = pos.flip(flipLine);
            }
            return pos.rotate(self.parent().angle()).add(self.parent().pos());
        },
        null,
        [this.parent().pos, this.parent().angle, this.parent().onTopLayer, this.description]
    );
    this.angle = this.shadow("angle",
        function(){
            return self.description().angle() + self.parent().angle();
        },
        null,
        [this.parent().angle, this.description]
    );

    this.segmentedGeometry = this.cachedFunction("segmentedGeometry",
        function(precision){
            // return the entire pad
            var basePoly = self.description().segmentedGeometry(precision);
            var poly = basePoly.scale(self.parent().onTopLayer() ? 1 : -1, 1)
                               .rotate(self.parent().angle())
                               .translate(self.parent().pos());
            return poly;
        },
        [this.parent().pos, this.parent().angle, this.parent().onTopLayer, this.description]
    );

    this.bufferedSegmentedGeometry = this.cachedFunction("bufferedSegmentedGeometry",
        function(precision, layerIndex, layerType, bufferSize) {
            return self.segmentedGeometry(precision, layerIndex, layerType).buffer(bufferSize);
        },
        [this.segmentedGeometry]
    );

    this.boundingBox = this.cachedFunction("boundingBox",
        function () { return self.description().getBB()
                               .scale(self.parent().onTopLayer() ? 1 : -1, 1)
                               .rotate(self.parent().angle())
                               .translate(self.parent().pos());
        },
        [this.segmentedGeometry]
    );
};

PcbHole.prototype.toString = function () {
    return "PcbHole("+this.pos().toString()+")";
};

PcbHole.prototype.getLayers = function () {
    var layers = new lib_core.Collections.HashSet();
    for(var i=0; i<this.parent().parent().number_of_layers(); i++) {
        layers.add(i);
    }
    return layers;
};

